import { writable } from 'svelte/store'

export const dateFilter = writable([
    {
        dateIni:new Date('2021-04-13'),
        dateEnd:new Date('2021-04-13')
      }
])